export { BrowserTracing } from './browsertracing';
export { registerRequestInstrumentation, defaultRequestInstrumentationOptions, } from './request';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/tracing/esm/browser/index.js
// module id = 1128
// module chunks = 115